<div
    class="datiq-select rounded"
    [ngClass]="{
        'datiq-select__thin':
            settings?.style === 'thin' || settings?.style === 'dark',
        'datiq-select__dark': isDark(),
        'panel-open': panelOpen
    }"
>
    <ng-container *ngIf="selectControl$ | async"></ng-container>
    <ng-container *ngIf="inputControl$ | async"></ng-container>
    <ng-container *ngIf="formGroup$ | async"></ng-container>
    <ng-container *ngIf="inputStatusControl$ | async"></ng-container>

    <mat-form-field
        class="datiq-select__form-field"
        [appearance]="settings?.appearance || 'outline'"
        [hideRequiredMarker]="true"
    >
        <mat-label
            class="datiq-select__label"
            [ngClass]="{'override-label': settings?.overrideLabel}"
            [class.text-white]="settings?.style === 'dark'"
            *ngIf="settings?.label"
        >
            {{ settings?.label }}
        </mat-label>
        <ng-container *ngIf="!settings?.multiple">
            <mat-select
                [attr.data-testid]="settings?.id"
                [id]="settings?.id"
                [placeholder]="settings?.placeholder"
                [hideSingleSelectionIndicator]="true"
                [class.!text-white]="isDark()"
                [class.!border-dat-blue-500]="isDark()"
                [formControl]="selectControl"
                (selectionChange)="onSelectionChange($event.value)"
                [panelClass]="panelClasses"
                (openedChange)="this.onOpenChanged($event)"
                (focus)="focused.emit()"
                class="h-9"
            >
                <ng-container *ngFor="let option of settings?.options">
                    <mat-option
                        [id]="option?.id"
                        (change)="selectSingle(option)"
                        [value]="option.value"
                        [disabled]="option.disabled"
                        [matTooltip]="option.tooltip"
                        [class.text-white]="isDark()"
                        [class.!bg-dat-grey-900]="isDark()"
                        [class.!min-h-[31px]]="isDark()"
                        [class.hover:!bg-dat-grey-800]="isDark()"
                        [class.active:bg-dat-grey-300]="!isDark()"
                        [class.hover:!bg-dat-blue-100]="!isDark()"
                        [class.hover:!bg-opacity-30]="!isDark()"
                        [matTooltipClass]="settings?.tooltipClass"
                        [matTooltipPosition]="
                            option?.tooltipPosition ?? 'below'
                        "
                        class="bg-white"
                    >
                        <mat-radio-group>
                            <span
                                [class.text-white]="isDark()"
                                [class.!bg-transpatent]="isDark()"
                                class="datiq-select__option__radio__label min-h-[40px] text-black font-body-2"
                            >
                                {{ option.display }}
                            </span>
                        </mat-radio-group>
                    </mat-option>
                </ng-container>
            </mat-select>
        </ng-container>
        <ng-container *ngIf="settings?.multiple">
            <mat-select
                [id]="settings?.id"
                [placeholder]="settings?.placeholder"
                [formControl]="selectControl"
                panelClass="select"
                (selectionChange)="onSelectionChange($event.value)"
                multiple
                class="datiq-select__select--multi"
                (openedChange)="this.onOpenChanged($event)"
            >
                <mat-select-trigger>
                    <mat-chip-grid>
                        <ng-container *ngFor="let option of settings?.value">
                            <mat-chip-row
                                class="datiq-select__chip"
                                [removable]="true"
                                (removed)="selectMulti(false, option)"
                            >
                                <span class="datiq-select__chip__label">
                                    {{ option.display }}
                                </span>
                                <mat-icon
                                    svgIcon="app:close"
                                    matChipRemove
                                ></mat-icon>
                            </mat-chip-row>
                        </ng-container>
                    </mat-chip-grid>
                </mat-select-trigger>
                <ng-container *ngIf="settings?.multiple">
                    <ng-container *ngFor="let option of settings?.options">
                        <mat-option
                            [value]="option.value"
                            [disabled]="option.disabled"
                            [matTooltip]="option.tooltip"
                            [matTooltipClass]="settings?.tooltipClass"
                        >
                            <span
                                [class.text-white]="isDark()"
                                class="datiq-select__option__checkbox__label"
                            >
                                {{ option.display }}
                            </span>
                        </mat-option>
                    </ng-container>
                </ng-container>
            </mat-select>
        </ng-container>
        <ng-container *ngIf="!!settings?.hint">
            <mat-hint>
                {{ settings?.hint }}
            </mat-hint>
        </ng-container>
        <ng-container *ngIf="settings?.suffixIcon">
            <mat-icon
                class="datiq-select__suffix__icon"
                [svgIcon]="settings?.suffixIcon"
            ></mat-icon>
        </ng-container>
        <mat-error class="datiq-select__error">
            {{
                customErrorMessage?.length
                    ? customErrorMessage
                    : getErrorMessage()
            }}
        </mat-error>
    </mat-form-field>
</div>
